import React from "react";

const AffiliateTerms = () => {
  return (
    <div className="container">
      <div className="main">
        <div className="title">JAMMABLE AFFILIATE PROGRAM TERMS OF SERVICE</div>
        Last updated: 07/12/2023 <n />
        This Affiliate Program Terms of Service Agreement (the
        &quot;Agreement&quot;) is made by and between Voicify AI LTD, a
        corporation, (hereafter &quot;Jammable&quot;, &quot;us&quot;,
        &quot;we&quot;, &quot;our&quot;), and you, as an Affiliate applicant
        (hereafter &quot;you&quot;, &quot;your&quot;, &quot;Affiliate&quot;).
        <div className="subtitle">1. AGREEMENT</div>
        Your participation in the Jammable Affiliate Program (the
        &quot;Program&quot;) is conditional on your acceptance of this
        Agreement. By participating in the Program, you agree to be bound by
        this Agreement.
        <div className="subtitle">2. ELIGIBILITY</div>
        You must be at least 13 years old to participate in the Program. By
        participating in the Program, you represent and warrant that you meet
        this age requirement.
        <div className="subtitle">3. PROHIBITED ACTIVITES</div>
        Affiliates are prohibited from:
        <n /> - Running Google Search Ads or any other online advertising that
        direct traffic to our website. <n /> - Using any form of spam or
        unsolicited commercial email in promoting Jammable. <n /> - Making false
        or misleading statements in any promotional materials about Jammable.{" "}
        <n /> - Engaging in any deceptive or fraudulent activity. e. Violating
        any applicable laws or regulations, or the rights of any third party.
        Any violation of this clause could result in termination of your
        affiliate account.
        <div className="subtitle">4. LINKING</div>
        Upon acceptance into the Program, links will be made available to you
        through the affiliate interface. Your use of the links must comply with
        all the terms of this Agreement.
        <div className="subtitle">5. COMMISSIONS</div>
        Affiliates will earn a standard commission rate of 20% for each purchase
        by a user that is referred to our site from an Affiliate link, provided
        the user completes the purchase within 30 days.
        <div className="subtitle">6. PAYMENT</div>
        Payments will be made once a month for the preceding month&apos;s earned
        commissions. All payments are made in USD.
        <div className="subtitle">7. TERMINATION</div>
        TERMINATION Either party may terminate this Agreement at any time, with
        or without cause, by giving the other party notice of termination.
        Breach of the terms of this Agreement, including running Google Search
        Ads for our website, will result in immediate termination of your
        Affiliate account.
        <div className="subtitle">8. MODIFICATION</div>
        We reserve the right to change any of the terms and conditions within
        this Agreement at any time and in our sole discretion.
        <div className="subtitle">9. LIMITATION OF LIABILITY</div>
        Jammable will not be liable for any indirect, special, or consequential
        damages, or any loss of revenue, profits, or data, arising in connection
        with this Agreement or the Program.
        <div className="subtitle">10. Contact Us</div>
        If you have any questions about these Terms, please contact us: By
        email: affiliates@jammable.com
      </div>
    </div>
  );
};

export default AffiliateTerms;
